// extracted by mini-css-extract-plugin
module.exports = {"root":"FeedbackPostDrawer_root__OgeLq","status":"FeedbackPostDrawer_status__zVi0V","tags":"FeedbackPostDrawer_tags__6d5I0","description":"FeedbackPostDrawer_description__zqlXJ"};